export default __webpack_public_path__ + "locales/en/Files.json?hash=b9e053fa8f832ad108e5bb69ef8034f5";